<section>

    <app-navbar></app-navbar>

    <body>
        <div class="accordion pt-4" id="accordionExample">
            <div class="card">
              <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                  <button class="btn btn-link btn-block text-center" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    Misión
                  </button>
                </h2>
              </div>
          
              <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                <div class="card-body">
                    Ayudar a l@s protagonistas recién egresados de las diversas carreras técnicas del CTCCOS-INATEC a insertarse en el campo laboral, contribuyendo con el desarrollo socio-económico del país.
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="headingTwo">
                <h2 class="mb-0">
                  <button class="btn btn-link btn-block text-center collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Visión
                  </button>
                </h2>
              </div>
              <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                <div class="card-body">
                    Promover el empleo en los diversos sectores socio-productivos brindando personal técnico calificado que respondan a las demandas de las diferentes organizaciones publicas y privadas.
                </div>
              </div>
            </div>
            
          </div>
    </body>

    <app-foot></app-foot>

</section>    